import { DATE_FORMATS } from "../constants";
import { COUNTRY_CODE } from "../constants/intl";
import { FEE_TAX_SETTING, IDanceClass } from "../models";
import { calculatePostTaxAmount, formatCurrency } from "./currencyFormatter";

export const splitByUpperCase = (input?: string): string => !input ? '' : (
  `${input.replace(/([A-Z](?=[a-z]+)|[A-Z]+(?![a-z]))/g, ' $1').slice(1)}`
);

export const formatDanceClassAgeString = (ageDetails: Partial<IDanceClass>): string => {
  if (!ageDetails.minAge) {
    return `${ageDetails.maxAge} and under`;
  } else if (!ageDetails.maxAge) {
    return `${ageDetails.minAge}+`;
  } else if (ageDetails.minAge === ageDetails.maxAge) {
    return ageDetails.minAge.toString();
  } else {
    return `${ageDetails.minAge} - ${ageDetails.maxAge}`;
  }
}

export const formatDanceClassInclusiveFee = (danceClass: IDanceClass, countryCode: COUNTRY_CODE): string => {
  const inclusiveFee = danceClass.feeTaxSetting === FEE_TAX_SETTING.TAX_EXCLUDED ? calculatePostTaxAmount(danceClass.fee, countryCode) : danceClass.fee;
  return formatCurrency(inclusiveFee, countryCode);
}

export const formatDanceClassTime = (danceClass?: Partial<IDanceClass>): string => {
  if (!danceClass?.startTime || !danceClass?.endTime) {
    return '';
  }

  return `${danceClass.startTime.format(DATE_FORMATS.HourMinute)} - ${danceClass.endTime.format(DATE_FORMATS.HourMinute)}`
}

export const formatDanceClassNameWithoutAge = (danceClass?: Partial<IDanceClass>): string => {
  if (!danceClass) {
    return '';
  } else if (danceClass.name) {
    return danceClass.name;
  }

  return splitByUpperCase(danceClass.danceStyle);
}

export const formatDanceClassName = (danceClass?: Partial<IDanceClass>): string => {
  if (!danceClass) {
    return '';
  } else if (danceClass.name) {
    return danceClass.name;
  }

  return [
    splitByUpperCase(danceClass.danceStyle),
    danceClass.minAge || danceClass.maxAge ? ` (${formatDanceClassAgeString(danceClass)})` : ''
  ].join('');
}

export const formatFullClassName = (classDetails: IDanceClass): string => {
  return `${formatDanceClassName(classDetails)} - ${classDetails.dayOfWeek}, ${formatDanceClassTime(classDetails)}`;
}
export const formatFullClassNameForTrial = (classDetails: IDanceClass, trialDate: string): string => {
  return `${formatDanceClassName(classDetails)} - ${trialDate}, ${formatDanceClassTime(classDetails)}`;
}

export const cleanupPhoneNumber = (number?: string | null): string => {
  if (!number) {
    return '';
  }

  // eslint-disable-next-line no-useless-escape
  return number.replace(/[ \(\)\-]/g, '');
}